import { ILandingConsoleStore, useLandingConsoleStore } from "src/modules/pe-landing-module/data/store"
import { getLandingContainer } from "../../../utils/getLandingContainer"
import { IPanelStore, usePanelStore } from "../../../UIX/store"
import DragTool from "./DragTool"
import EditTool from "./EditTool"
import InnerTool from "./InnerTool"
import TransformTool from "./TransformTool"
import FloatTool from "./FloatTool"
import ColorTool from "./ColorTool"

/* Protopia Ecosystem component */
export interface IToolsPanelProps {
   
}
const ToolsPanel = (props: IToolsPanelProps): JSX.Element => {
    const settings = useLandingConsoleStore((state:ILandingConsoleStore) => state.settings)
    const isHidePanels: boolean     = usePanelStore((state: IPanelStore) => state.isHidePanels)
    if(!settings.toolPanel || !!isHidePanels) return <></>
    
    return <div className='landing-tools-panel'>
       <EditTool />
       {/* <TransformTool /> */}
       {/* <InnerTool /> */}
       <DragTool />
       <div className="tools-divider"/>
       <FloatTool />
       <div className="tools-divider"/>
       <ColorTool />
    </div>
}
export default ToolsPanel

export const setCursor = (cursor: string) => {
    const landing = getLandingContainer().querySelector(".landing-transform-container") as HTMLElement
    landing.style.cursor = cursor; // "move"
}